import {Component, OnDestroy, OnInit} from "@angular/core";
import {DOCUMENT_TYPES, ITEM_ID_TYPE, VALUE_TYPE} from "../../enums/enums";
import {BusService, INewDocumentEvent} from "../../services/bus.service";
import {paramsHelper} from "../../helpers/params-helper";
import {UI_TEXTS} from "../../enums/e-texts";
import {IDocument} from "../../interfaces/document.definition";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {localeUtils} from "../../helpers/locale-utils";
import {PickService} from "../../services/pick.service";
import {JP} from "../../helpers/jp";
import {CollectionService} from "../../services/collection.service";
import {createObjectLink, createObjectLinkQuery} from "../../helpers/create-object-link";
import {ISearchItem} from "../../definitions";
import {getDebugContext} from "@angular/core/src/errors";
import {Subject} from "rxjs/Subject";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";


@Component({
  templateUrl: "./offers-page.component.html"
})


export class OffersPageComponent implements OnInit, OnDestroy  {
  UI_TEXTS = UI_TEXTS;

  pageParams = paramsHelper.page()
    .setTitle("Обычные офферы");

  collectionParams = paramsHelper.collection()
    .setObjectType(DOCUMENT_TYPES.OFFER)
    .setDefaultListLabels()
    .setItemLabelQuery('codeName')
    //.setItemLabelQuery(`locales.${localeUtils.getLocale()}[key=name].value.0`)
    .setSearchParams(paramsHelper.search()
      .addNumberParam("id")
      .addParam('codeName', SEARCH_PROP_TYPES.STRING, ""));

  VALUE_TYPE = VALUE_TYPE;
  document: IDocument;
  offerLots: Array<ISearchItem> = [];
  loadedOfferTypesList:Array<IDocument> = [];
  currentOfferType:IDocument;

  private unsubscribe:Subject<void> = new Subject<void>();

  constructor(private busService: BusService,
              private pickService: PickService,
              private collectionService: CollectionService) {

  }


  ngOnInit(){
    this.busService.onDocumentUpdated
      .takeUntil(this.unsubscribe)
      .subscribe(
        e => this.onDocumentUpdated(e));

    this.loadOfferTypesList();
  }

  ngOnDestroy(){
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  createLotLink(lotId:number):string[] {
    var lot:ISearchItem = this.getSearchItem(lotId);
    return createObjectLink(lot);
  }

  createLotLinkQuery(lotId:number):any {
    var lot:ISearchItem = this.getSearchItem(lotId);
    return createObjectLinkQuery(lot);
  }

  getLotName(lotId:number):string {
    var lot:ISearchItem = this.getSearchItem(lotId);
    return lot ? lot.locales ? localeUtils.findName(lot): 'NO NAME' : "MISSING";
  }

  onAddLotClick() {
    this.pickService.pickIdAndPushToArray(this.document, "/lotsIds", ITEM_ID_TYPE.OFFERS_LOTS)
      .subscribe(result => {
        this.loadLotsNames();
      });
  }

  /*getOfferTypesListLabel(offerType:IDocument){
    if (offerType.id >= 0)
    {
      return offerType.name;
    }
    else
    {
      return "NONE";
    }
  }*/

  private loadOfferTypesList()
  {
    const params = paramsHelper
      .loader()
      .setEndpointId(E_ENDPOINTS.API)
      .setSearchParams(paramsHelper.search()
        .addParam("_type", SEARCH_PROP_TYPES.STRING,
          DOCUMENT_TYPES.OFFER_TYPE).json
      )
      .setNavParams(0, 9999);

    this.collectionService.loadChunkCached(params)
      .takeUntil(this.unsubscribe)
      .subscribe(r => {
        this.loadedOfferTypesList = r.documents;
        if (this.loadedOfferTypesList.length > 0)
        {
          this.currentOfferType = this.loadedOfferTypesList[0];
        }
      });
  }

  private getSearchItem(id:number):ISearchItem
  {
    for (let i = 0; i < this.offerLots.length; i++)
    {
      if (this.offerLots[i].id == id)
      {
        return this.offerLots[i];
      }
    }
    return null;
  }

  private onDocumentUpdated(e: INewDocumentEvent) {
    this.document = e.document;

    if (this.document) {
      this.loadLotsNames();
    }
  }

  private loadLotsNames()
  {
    this.offerLots = [];
    const lotsIds = JP.get(this.document, "/lotsIds") || [];
    if (lotsIds === 0) {
      return;
    }

    const searchParams = paramsHelper.search()
      .addParam("id", SEARCH_PROP_TYPES.ENUM_MULTI, lotsIds)
      .addParam("_type", SEARCH_PROP_TYPES.STRING, DOCUMENT_TYPES.OFFER_LOTS)
      .json;

    const params = paramsHelper.loader()
      .setEndpointApi()
      .setAdditionalParam("filter", { id: 1, _type: 1, category: 1, locales: 1})
      .setSearchParams(searchParams);

    this.collectionService.search(params)
      .subscribe(
        r => {this.offerLots = r;});
  }


}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/offers/offers-page.component.ts